// extracted by mini-css-extract-plugin
export default {"main":"f97d7c9d80 _90c6a83885","xmark":"_807bc685b9","fl_img":"_8967381313 _7ba76e53b8"};